import React from "react";
import SurveyNotification from "../SurveyNotification";
import NewsletterNotification from "../NewsletterNotification";
import useSurveyEligibility from "./useSurveyEligibility";
import useNewsletterEligibility from "./useNewsletterEligibility";

/**
 * Notification area that coordinates promotional notifications.
 *
 * Shows at most one promotional notification at a time, with priority:
 * 1. Survey notification (time-bound)
 * 2. Newsletter notification (evergreen)
 *
 * @returns {JSX.Element|null} The highest-priority eligible notification, or null.
 */
const PromotionalNotificationArea = () => {
	const survey = useSurveyEligibility();
	const newsletter = useNewsletterEligibility();

	// The survey's eligibility depends on a request now, so it has to be awaited before falling
	// through — otherwise the newsletter wins the race and its notification flashes up only to be
	// replaced once the survey resolves.
	if ( survey.isLoading ) {
		return null;
	}

	if ( survey.isEligible ) {
		return <SurveyNotification onDismiss={ survey.dismiss } isEligible={ true } />;
	}

	if ( newsletter.isLoading ) {
		return null;
	}

	if ( newsletter.isEligible ) {
		return <NewsletterNotification email={ newsletter.email } onDismiss={ newsletter.dismiss } />;
	}

	return null;
};

export default PromotionalNotificationArea;
